export const generatedStoriesPageMessages = {
  title: 'Generated Stories',
  subtitle: 'View and manage your generated stories',
  loading: 'Loading generated stories...',
  errorLoading: 'Failed to load generated stories',
  noStoriesFound: 'No generated stories found',
  noStoriesDescription: 'Create your first story to get started',
  deleteAction: 'Delete Story',
  openPreviewAction: 'Preview Story',
  printAction: 'Print Story',
  printSuccess: 'Print PDF created',
  printError: 'Failed to create print PDF',
  printGenerating: 'PDF is generating',
  pdfDialogTitle: 'PDF Ready',
  pdfDialogDescription:
    'Your story PDF has been generated successfully. Click the button below to download it.',
  downloadPdfButton: 'Download PDF',
  deleteConfirmTitle: 'Delete Generated Story',
  deleteConfirmMessage:
    'Are you sure you want to delete this generated story? This action cannot be undone.',
  deleteSuccessMessage: 'Generated story deleted successfully',
  deleteErrorMessage: 'Failed to delete generated story',
  deleting: 'Deleting...',

  // Entity card labels
  statusLabel: 'Status',
  templateLabel: 'Template',
  createdAtLabel: 'Created',
  generationModeLabel: 'Generation Mode',

  // Status values
  statusPending: 'Pending',
  statusCompleted: 'Completed',
  statusErrorText: 'Text Generation Error',
  statusErrorImages: 'Image Generation Error',
  statusErrorPreview: 'Preview Generation Error',
  statusPreviewCompleted: 'Preview Completed',

  // Generation mode values
  generationModeBasic: 'Basic',
  generationModeCustom: 'Custom',
} as const;
